import ApiClient from './client'

/**
 * Declared return shapes are the *wrapped* ones (`Promise<{ data: T }>`) — the
 * promise middleware re-wraps every response under `.data` on the dispatched
 * action. See the DispatchProps note in redux/types.ts.
 */
export type Wrapped<T> = Promise<{ data: T }>

export default class Base {
  apiClient: ApiClient

  constructor(apiClient: ApiClient) {
    if (!apiClient) {
      throw new Error('[apiClient] required')
    }
    this.apiClient = apiClient
  }
}
